var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", {
    staticClass: "invoiceDetail"
  }, [_c("div", {
    staticClass: "selectBox"
  }, [_c("span", {
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(_vm._s(_vm.$t("抬头类型")))]), _c("a-select", {
    staticStyle: {
      width: "160px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("抬头类型")
    },
    on: {
      change: _vm.invoiceHeadChange
    },
    model: {
      value: _vm.invoiceHeadType,
      callback: function ($$v) {
        _vm.invoiceHeadType = $$v;
      },
      expression: "invoiceHeadType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "P"
    }
  }, [_vm._v(_vm._s(_vm.$t("个人")))]), _c("a-select-option", {
    attrs: {
      value: "C"
    }
  }, [_vm._v(_vm._s(_vm.$t("公司")))])], 1)], 1), _c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("发票信息")))]), _vm.invoiceHeadType === "P" ? [_c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("发票内容")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("开票姓名")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("序号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox",
    staticStyle: {
      "border-bottom": "20px solid #e8e8e8",
      height: "60px"
    }
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("金额")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])])] : _vm._e(), _vm.invoiceHeadType === "C" ? [_c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("发票抬头")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("纳税人识别号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("发票内容")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("序号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("金额")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "moreTips"
  }, [_c("b", [_vm._v(_vm._s(_vm.$t("更多信息")))])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("开户行名称")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("开户行帐号")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("公司联系电话")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("公司地址")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox",
    staticStyle: {
      "border-bottom": "20px solid #e8e8e8",
      height: "60px"
    }
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("备注信息")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])])] : _vm._e(), _c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("接收方式")))]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("手机号码")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "fieldBox",
    style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
  }, [_vm._v(" " + _vm._s(_vm.$t("电子邮箱")) + " ")]), _c("div", {
    style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
  }, [_vm._v("xx")])])], 2), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };